{
  "Login": {
    "Title": "ログインして領収書を保存してください",
    "WaitingScreenLoginTitle": "ログイン",
    "KakaoButton": "Kakaoで続ける",
    "NaverButton": "LINEで続ける",
    "GoogleButton": "Googleで続ける",
    "LineButton": "LINEでログイン",
    "FacebookButton": "Facebookで続ける",
    "OR": "もしくは",
    "MobileNumber": "携帯番号",
    "Continue": "携帯番号で続ける",
    "EndUserLicenseAgreement": "利用許諾",
    "PrivacyPolicy": "プライバシーポリシー",
    "EulaAndPrivacyPolicyTerm": "続けることで、\n{eula}と{privacyPolicy}に同意する",
    "OtherLoginMethods": "その他のログイン方法",
    "SelectCountry": "国または場所を選択してください",
    "EncourageSocialLogin": "より速く安全なエクスペリエンスを実現",
    "EncourageSocialLogin2": "ソーシャルログイン経由でサインインする"
  },
  "BottomNavbar": {
    "Receipts": "電子レシート",
    "Account": "アカウント"
  },
  "PhoneVerification": {
    "Title": "電話番号承認",
    "EnterCode": "コードを入力ご入力下さい。",
    "SMSDiscription": "認証コードをSMSにて送信致しました。",
    "EnterOTP": "6桁のコードをご入力下さい。",
    "InvalidOtp": "無効なコードです。",
    "TryAgainInfo": "もう一度お試し下さい。",
    "OTPExpireTime": "OTPコードの有効期限は次のとおりです",
    "OTPNotArrive": "コードを受け取っていない場合は、",
    "Resend": "OTPを再送信する",
    "ChangePhone": "電話番号を変更する",
    "ResendToast": "新しい6 桁のOTPコードを携帯電話に送信しました。"
  },
  "ReceiptLoader": {
    "PreparingText": "電子レシート準備中です。",
    "TakingLongerText": "電子レシートの発行に少しお時間が掛かっております。",
    "NotifyText1": "電子レシートが用意できたら、お知らせを受け取る。",
    "NotifyText2": "電子レシートが準備出来次第、お知らせ致します。",
    "OKButton": "はい",
    "LoginButton": "ログイン",
    "NotifyMeButton": "お知らせを受け取る",
    "ReceiptWait": "取引が完了すると、領収書が表示されますので、しばらくお待ちください。",
    "UtilisedReceiptText": "この電子レシートは別のアカウントに紐付けされました。",
    "ReceiptExpiredText": "未保存のレシートが期限切れになりました。次回からレシートの保存をお願い致します。",
    "ReceiptLinkExpired": "レシートリンクの有効期限が過ぎています。次回から早めにレシートの保存をお願い致します。",
    "VoidReceiptTitle": "このレシートは無効です。",
    "VoidReceiptSubtitle": "詳細は店舗へお問い合わせください。",
    "SharedReceiptText": "シェアされたレシートを参照するには、ログインをして下さい。",
    "InvalidHashText": "レシートを読み込むことができません。受信URLが正しくありません。"
  },
  "SaveReceipt": {
    "Description": "このレシートは現在保存されていません。下記をタップして保存して下さい。",
    "SaveReceipt": "レシートを保存する",
    "SaveInfo": "レシートをPiperksへ保存する",
    "UpdatedGoogleWallet": "レシートがGoogleウォレットに更新されました"
  },
  "PushNotification": {
    "NewReceipt": "プッシュ通知オンで新しいレシートへのアクセスを簡単に",
    "Notification": "通知（お知らせ）",
    "AllowNotification": "Piperksからのお知らせを許可する",
    "Deny": "許可しない",
    "Allow": "許可",
    "NotificationInfo": "レシートが届き次第お知らせします。"
  },
  "WhatsAppPrompt": {
    "Title": "質問をどうぞ",
    "SubTitle": "トピックを選択して下さい。",
    "IssueWithPurchase": "購入品に問題がある",
    "Feedback": "一般的なフィードバック",
    "ReceiptError": "レシートのエラー",
    "AccountIssue": "アカウントに問題がある",
    "ReceiptNumber": "レシート番号は {receiptNo}",
    "IssuePurchaseText": "購入に関して問題があります。",
    "FeedbackText": "一般的なフィードバックがあります。",
    "ReceiptErrorText": "レシートに問題があります。",
    "AccountIssueText": "アカウントに問題があります。"
  },
  "QRReader": {
    "Title": "レシートのQRコードをスキャンしてください",
    "BackButton": "戻る",
    "InvalidQR": "無効な QR",
    "InvalidQRInfo": "レシートのQRコードをスキャンしてください。"
  },
  "PWAPrompt": {
    "Description": "ワンタッチインストールでオフラインでもレシートにアクセスする。",
    "Install": "インストール"
  },
  "MyReceipts": {
    "Title": "レシート履歴",
    "ReceiptLoadingText": "読み込み中...",
    "EmptyInfo": "ここにレシートが追加されます。",
    "NotifyInfo": "レシートを受信したらお知らせ致します。",
    "EmptyFilter": "より多くのレシートを表示するため、フィルター設定を変更する",
    "EndOfReceipts": "すべてのレシートが表示されました"
  },
  "SalesReceipt": {
    "HelpText": "お困りごとはありますか？",
    "WhatsAppButton": "Whatsappへメッセージを下さい。",
    "FollowUs": "フォローお願いします！:"
  },
  "ReceiptExport": {
    "ExportingReceiptText": "レシートをエクスポート中です",
    "ReceiptExportSuccessText": "レシートをダウンロード中です"
  },
  "Settings": {
    "ProfileCompleteText": "プロフィールを完成させる",
    "AccountInformation": "アカウント情報",
    "EnterDetailsText": "アカウントを回復する為、詳細のご入力をお願いします。",
    "Name": "名前",
    "Edit": "編集",
    "Phone": "電話番号",
    "Gender": "性別",
    "Dob": "生年月日",
    "Email": "メールアドレス",
    "HomeAddress": "住所",
    "Male": "男性",
    "Female": "女性",
    "Other": "その他",
    "Indonesia": "インドネシア",
    "Malaysia": "マレーシア",
    "Singapore": "シンガポール",
    "SouthKorea": "韓国",
    "Japan": "日本",
    "SetNow": "設定をする",
    "LocationAndLanguage": "地域と言語",
    "DisplayLanguage": "ご希望の言語を選択して下さい。",
    "Country": "国",
    "Language": "言語",
    "LocationAccessTitle": "位置情報",
    "LocationAccessDescription": "言語の自動設定を許可する",
    "Notification": "お知らせ",
    "PushNotification": "プッシュ通知",
    "GetUpdates": "大切なお知らせを受け取る",
    "ReceiptAlerts": "レシートアラート",
    "NotifiedLatestReceiptsAndUpdates": "最新のレシートとお知らせを受け取る",
    "LinkedAccounts": "リンクされたアカウント",
    "EnableLogins": "有効にしてログインを高速化します",
    "PwaInstallButton": "Piperksアプリをインストールする",
    "ContactSupportButton": "コンタクトサポート",
    "LogoutButton": "ログアウト",
    "Version": "バージョン",
    "SupportViaEmail": "メールでサポートを受ける",
    "SupportViaWhatsApp": "Whatsappでサポートを受ける"
  },
  "Modal": {
    "PushNotif": {
      "Title": "プッシュ通知を許可しますか？",
      "Message1": "プッシュ通知を可能にするために、下記の方法に従って下さい。",
      "Message2": "1. URLの左にある情報アイコンをクリック",
      "Message3": "2. 通知の横の「確認」もしくは「許可」のボタンを選択",
      "Message4": "3. アップデートを適応するためにページを更新して下さい"
    },
    "Location": {
      "Title": "位置情報を有効にしますか？",
      "Message1": "位置情報を有効にするために、下記の方法に従って下さい。",
      "Message2": "1. URLの左にある情報アイコンをクリック",
      "Message3": "2. 通知の横の「確認」もしくは「許可」のボタンを選択",
      "Message4": "3. アップデートを適応するためにページを更新して下さい。"
    },
    "BaseCountry": {
      "Title": "国",
      "Message1": "アカウントページに記載されている国が、お客様のデータが保管される場所です。",
      "Message2": "あなたのデータは現在「{0}」です。",
      "Message3": "データの保存場所を変更したい場合は、",
      "Action1": "ここをクリックしてください。"
    }
  },
  "Message": {
    "Subject": "Piperksのアプリについてサポートが必要な場合",
    "TypeMessage": "メッセージを入力して下さい。",
    "HelpTroubleshoot": "【トラブルシューティングの為、このセクションを削除しないで下さい】",
    "PhoneModel": "携帯の機種: ",
    "PhoneOS": "OSバージョン: ",
    "BrowserVersion": "ブラウザーのバージョン: ",
    "RegisteredID": "登録したID: ",
    "LatestReceipt": "直近のレシート: "
  },
  "ReceiptDetail": {
    "Store": "店舗：",
    "POS": "POS：",
    "Cashier": "レジ：",
    "TotalSpend": "総額",
    "PreSettlementTotalSpend": "支払いの処理中",
    "YouSave": "あなたは保存した",
    "TotalPaid": "支払総額",
    "Change": "お釣り",
    "Tax": "税：",
    "Items": "商品",
    "ItemReturned": "# 個のアイテムが返品されました",
    "ItemSold": "# 販売された商品",
    "WifiPassword": "Wi-Fiパスワードをコピーする",
    "FreeWifi": "無料Wi-Fi",
    "PreSettlementTotal": "これは最終的なレシートではありません。お支払いが完了すると、最終的なレシートが表示されます。"
  },
  "Receipt": {
    "Today": "今日",
    "Yesterday": "昨日"
  },
  "DemoError": {
    "title": "このアプリはデモバージョンです。",
    "message": "承認されたデモURLを使用するか、URLをリクエストして下さい。"
  },
  "DataPrompt": {
    "Title": "アカウントを確認",
    "Body": "情報を確認して、アカウントの検証もしくはリカバリーのためにレシートを保存してください。",
    "Gender": "性別",
    "YOB": "生まれた年",
    "Submit": "送信する",
    "Later": "後で",
    "Select": "選択する",
    "DrawerTitle": "リカバリーの詳細を確認することでレシートの安全を確保して下さい。",
    "DrawerBody": "詳細を確認"
  },
  "Eula": {
    "Title": "ユーザー合意"
  },
  "SortFilter": {
    "Title": "並び替えとフィルター",
    "SortBy": "並び替え",
    "DateAsc": "日付（古い-新しい）",
    "DateDesc": "日付（古い-新しい）",
    "TransactionAsc": "決済（低い-高い）",
    "TransactionDesc": "決済（高い-低い）",
    "DateRange": "日付範囲",
    "Store": "店舗",
    "SeeMore": "もっと見る",
    "ShowLess": "表示を減らす",
    "Apply": "適応する",
    "Reset": "リセット",
    "LastWeek": "先週",
    "LastMonth": "先月"
  },
  "KoreanExplicit": {
    "Title": "Please agree to use Piperks service",
    "AcceptAll": "Accept All",
    "Required": "Required",
    "TermOfUse": "Terms of Use ",
    "PrivacyPolicy": "Privacy Policy",
    "AgeConsent": "I am 14 years old or older",
    "Continue": "Continue",
    "ViewMore": "view more"
  },
  "Error": {
    "UnexpectedError": "予期しないエラーが発生しました!",
    "TryAgain": "しばらくしてからもう一度やり直してください。",
    "BtnTextOK": "OK",
    "BtnTextRetry": "リトライ",
    "OtpSendingFailed": {
      "Title": "OTPの送信に失敗しました",
      "Body": "数分後にもう一度お試しください"
    },
    "InvalidPhoneNumber": {
      "Title": "Failed to send OTP",
      "Body": "The phone number you provided is not in the correct format. Please enter your phone number without a country code."
    },
    "IncorrectOtp": {
      "Title": "不正なOTP",
      "Body": "登録した電話番号に送信されたOTPを確認してください"
    },
    "SocialLoginFailed": {
      "Title": "{ provider } のログインに失敗しました",
      "Body": "数分待ってから再試行してください"
    },
    "LoginUnsuccessful": {
      "Title": "ログイン失敗",
      "Body": "申し訳ありませんが、ログイン中にエラーが発生しました。 後でもう一度試してください"
    },
    "UserReceiptsQueryFails": {
      "Title": "レシート読み込みエラー",
      "Body": "申し訳ございませんが、レシート取得中にエラーが発生しました。 しばらくしてからもう一度お試しください"
    },
    "CreateTransactionError": {
      "Title": "トランザクション作成エラー",
      "Body": "申し訳ございませんが、レシートのトランザクションを作成できませんでした。 もう一度お試しださい"
    },
    "GetReceiptError": {
      "Title": "レシート取得エラー",
      "Body": "申し訳ございませんが、レシートの取得中に予期しないエラーが発生しました。 しばらくしてからもう一度お試しください"
    },
    "GetReceiptTemplateError": {
      "Title": "テンプレートの取得に失敗しました",
      "Body": "申し訳ありませんが、レシートテンプレートを取得中にエラーが発生しました。 しばらくしてからもう一度お試しください"
    },
    "LinkReceiptError": {
      "Title": "レシートリンクエラー",
      "Body": "申し訳ございませんが、レシートをアカウントにリンクできませんでした。 すぐにもう一度試してください"
    },
    "ReceiptSubscriptionError": {
      "Title": "リアルタイムレシートを取得できませんでした"
    },
    "AccountUpdateFailed": {
      "Title": "アカウントの更新に失敗しました",
      "Body": "申し訳ございませんが、アカウントの更新中にエラーが発生しました。 しばらくしてからもう一度お試しください"
    },
    "AccountRetrievalFailed": {
      "Title": "アカウントの取得に失敗しました",
      "Body": "申し訳ありませんが、アカウントデータの取得中にエラーが発生しました"
    },
    "ServerUnavailable": {
      "Title": "サーバーが利用できません",
      "Body": "現在、問題を修正中です。 数分後にもう一度お試しください"
    },
    "MissingQueryParam": {
      "Title": "レシートが見つかりません",
      "Body": "レシートリンクに不足があるようです。 再確認してもう一度お試しください"
    },
    "InvalidReceiptToken": {
      "Title": "レシートリンクが見つかりません",
      "Body": "システム内にレシートリンクが見つかりませんでした。 詳細については、レジの担当者にお問い合わせください。"
    },
    "ExpiredReceiptLink": {
      "Title": "レシートリンクの有効期限が切れています",
      "Body": "レシートリンクの有効期限が切れているようです。 新しいリンクについては、レジの担当者にお問い合わせください。"
    },
    "ExpiredShareReceipt": {
      "Title": "共有リンクの有効期限が切れています",
      "Body": "共有されたレシートリンクの有効期限が切れました。 送信者に新しいリンクを依頼するか、共有されたレシートのリンクを確認してください。"
    },
    "InvalidShareReceipt": {
      "Title": "共有リンクは使用できません",
      "Body": "共有されたレシートリンクは使用できません。 送信者に新しいリンクを依頼するか、共有されたレシートリンクをご確認ください。"
    }
  }
}
